import {
  Box,
  Button,
  Grid,
  MenuItem,
  Popover,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import ManageOffer from 'component/BuyerRegistration/ManageOffer';
import { useEffect, useState } from 'react';
import { fontsize14, menuitemfont, poppins500 } from 'theme/common.style';
import { DepositIcon } from 'component/BuyersMarketplace/Marketplaceicons';
import { ArrowDropDown } from '@mui/icons-material';
import Privateofferdetailslink from 'component/BuyersMarketplace/Privateofferdetailslinkpopup';
import PrivateOfferDetails from 'component/BuyerRegistration/PrivateOfferDetails';
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min';

export const Viewoffer = () => {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 213 213"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M124.25 8.875V71H186.375M186.375 204.125H26.625V8.875H133.125L159.75 35.5L186.375 62.125V204.125Z"
        stroke="black"
        stroke-width="4"
      />
      <path
        d="M133.632 136.656C133.632 140.923 132.565 144.933 130.432 148.688C128.384 152.443 125.312 155.6 121.216 158.16C117.205 160.72 112.427 162.256 106.88 162.768V173.136H98.56V162.768C90.5387 162 84.0533 159.483 79.104 155.216C74.1547 150.949 71.68 145.317 71.68 138.32H87.296C87.552 141.648 88.6187 144.421 90.496 146.64C92.3733 148.773 95.0613 150.139 98.56 150.736V122.576C92.8427 121.125 88.192 119.675 84.608 118.224C81.024 116.688 77.952 114.299 75.392 111.056C72.9173 107.813 71.68 103.376 71.68 97.744C71.68 90.6613 74.1547 84.816 79.104 80.208C84.0533 75.5147 90.5387 72.784 98.56 72.016V61.648H106.88V72.016C114.389 72.6987 120.405 75.088 124.928 79.184C129.536 83.1947 132.139 88.7413 132.736 95.824H117.12C116.864 93.1787 115.84 90.832 114.048 88.784C112.256 86.6507 109.867 85.2 106.88 84.432V112.08C112.597 113.445 117.248 114.896 120.832 116.432C124.416 117.883 127.445 120.229 129.92 123.472C132.395 126.629 133.632 131.024 133.632 136.656ZM86.528 96.976C86.528 100.475 87.552 103.205 89.6 105.168C91.7333 107.131 94.72 108.709 98.56 109.904V84.048C94.8907 84.4747 91.9467 85.7973 89.728 88.016C87.5947 90.2347 86.528 93.2213 86.528 96.976ZM106.88 150.736C110.635 150.139 113.579 148.645 115.712 146.256C117.845 143.781 118.912 140.837 118.912 137.424C118.912 134.011 117.845 131.365 115.712 129.488C113.664 127.525 110.72 125.947 106.88 124.752V150.736Z"
        fill="black"
      />
    </svg>
  );
};

export default function BuyerManageOffer(props) {
  const {
    setOpenBox,
    openBox,
    setTabDAta,
    Makeoffer,
    propertyId,
    getBuyerIndividualValue,
    confirmBuyerOffer,
    groupIt,
    groupCall,
    setDontallowtooffer,
    sharedpage,
    handleMakeOfferClick,
    setOfferHistoryState,
    setNewTabData,
    SetHideOthers,
    setShowPropertyTimer,
    handlemakeoffertab,
    setOpensolicitorpopup,
    setTypeofsolicitorpopup,
  } = props;
  const location = useLocation();
  const history = useHistory();
  const [manageOffer, setManageOffer] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [viewBuyerHistory, setViewBuyerHistory] = useState(false);
  const [privateOfferDetailsOpen, setPrivateOfferDetailsOpen] = useState(false);
  const [manageOfferData, setManageOfferData] = useState({}); // Add this to store manage offer data
  const { privateofferprice } = location.state ? location.state : '';
  const { propertyIds } = location.state ? location.state : '';
  const [viewPrivateOfferlinkpopup, setViewPrivateOfferlinkpopup] =
    useState(false);
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const openFromViewButton = location.state?.openBuyerManageOffer == true;
  useEffect(() => {
    if (openFromViewButton) {
      setManageOffer(true);
    }
  }, [location.state]);

  useEffect(() => {
    const offerPriceStr =
      getBuyerIndividualValue?.PropertyDetails?.privateOfferDetails
        ?.privateOfferPrice;
    const parsedOfferPrice = offerPriceStr
      ? parseFloat(offerPriceStr.replace(/[^0-9.-]+/g, ''))
      : null;
    if (
      propertyIds ==
      getBuyerIndividualValue?.PropertyDetails?.property?.propertyId
    ) {
      if (privateofferprice != null && privateofferprice !== undefined) {
        if (parsedOfferPrice == privateofferprice) {
          setManageOffer(true);
          history.push({
            pathname: history.location.pathname,
            state: {
              propertyIds: propertyId,
              privateofferprice: null,
            },
          });
        } else {
          setViewPrivateOfferlinkpopup(true);
        }
      }
    }
  }, [location.state, getBuyerIndividualValue]);

  const manageOfferClick = () => {
    setManageOffer(true);
  };
  const [autoScrollEnabled, setAutoScrollEnabled] = useState(false);
  const manageOfferClickk = () => {
    setManageOffer(true);
    setViewBuyerHistory(true);
    setAutoScrollEnabled(true);
  };
  const manageOfferClickClose = () => {
    setManageOffer(false);
    handleClosee();
  };
  const handleScrollToOfferHistory = () => {
    setViewBuyerHistory(true);
  };

  const handleClicke = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosee = () => {
    setAnchorEl(null);
  };

  const openn = Boolean(anchorEl);
  const id = openn ? 'simple-popover' : undefined;

  const data1 = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data1);
  const userId = userDetail?.userId;

  return (
    <Grid>
      <Box aria-describedby={id} onClick={handleClicke}>
        <Button
          disabled={sharedpage}
          onClick={handleClicke}
          sx={[
            menuitemfont,
            {
              ...poppins500,
              ...fontsize14,
              height: '30px',
              border: !sharedpage ? '1px solid #6C2AD2' : 'none',
              boxShadow: !sharedpage
                ? '0px 1px 4px rgba(0, 0, 0, 0.15)'
                : 'none',
              '.MuiOutlinedInput-notchedOutline': { border: 0 },
              outline: 'none',
              color: 'black',
              textTransform: 'none',
              whiteSpace: 'nowrap',
            },
          ]}
        >
          Action <ArrowDropDown />
        </Button>
      </Box>
      <Popover
        id={id}
        open={openn}
        anchorEl={anchorEl}
        onClose={handleClosee}
        PaperProps={{
          style: {
            boxShadow: 'none',
            border: '1px solid #D9D9D9',
            borderRadius: '4px',
            minWidth: '174px',
          },
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Typography>
          <MenuItem
            onClick={() => {
              handleClosee();
              manageOfferClick();
            }}
            value={10}
            sx={{
              ...poppins500,
              fontSize: '12px',
              color: '#112347',
              alignItems: 'center',
              justifyContent: 'left',
            }}
          >
            <Viewoffer />
            <span style={{ marginRight: '8px' }} />
            View Offer Details
          </MenuItem>
        </Typography>
        <MenuItem
          onClick={() => {
            handleClosee();
            manageOfferClickk();
          }}
          value={15}
          sx={{
            ...poppins500,
            fontSize: '12px',
            color: '#112347',
            alignItems: 'center',
            justifyContent: 'left',
          }}
        >
          <DepositIcon />
          <span style={{ marginRight: '8px' }} />
          Offer History
        </MenuItem>
        <MenuItem
          disabled={
            getBuyerIndividualValue?.PropertyDetails?.timerStatus == 'Pause'
          }
          onClick={() => {
            if (
              getBuyerIndividualValue?.PropertyDetails?.timerStatus == 'Pause'
            )
              return;
            // navigate to make offer popup
            if (matchessm) {
              handleMakeOfferClick();
              handleClosee();
              document.documentElement.scrollTo({
                top: 10,
                behavior: 'smooth',
              });
            } else {
              handlemakeoffertab();
              handleClosee();
            }
          }}
          value={20}
          sx={{
            ...poppins500,
            fontSize: '12px',
            color:
              getBuyerIndividualValue?.PropertyDetails?.timerStatus == 'Pause'
                ? '#9E9E9E'
                : '#112347',
            cursor:
              getBuyerIndividualValue?.PropertyDetails?.timerStatus == 'Pause'
                ? 'not-allowed'
                : 'pointer',
            alignItems: 'center',
            justifyContent: 'left',
            '&.Mui-disabled': {
              opacity: 1,
              color: '#9E9E9E',
            },
            '& svg path': {
              fill:
                getBuyerIndividualValue?.PropertyDetails?.timerStatus == 'Pause'
                  ? '#9E9E9E'
                  : '#112347',
              stroke:
                getBuyerIndividualValue?.PropertyDetails?.timerStatus == 'Pause'
                  ? '#9E9E9E'
                  : '#112347',
            },
          }}
        >
          <Makeoffer />
          <span style={{ marginRight: '8px' }} />
          Make Offer
        </MenuItem>
      </Popover>

      {manageOffer && (
        <ManageOffer
          open={manageOffer}
          onClose={manageOfferClickClose}
          propertyId={propertyId}
          getBuyerIndividualValue={getBuyerIndividualValue}
          groupIt={groupIt}
          groupCall={groupCall}
          moxouserId={true}
          viewBuyerHistory={viewBuyerHistory}
          setViewBuyerHistory={setViewBuyerHistory}
          handleScrollToOfferHistory={handleScrollToOfferHistory}
          autoScrollEnabled={autoScrollEnabled}
          setAutoScrollEnabled={setAutoScrollEnabled}
          setTabDAta={setTabDAta}
          handleMakeOfferClick={handleMakeOfferClick}
          setManageOffer={setManageOffer}
          // NEW PROPS for Private Offer Details
          privateOfferDetailsOpen={privateOfferDetailsOpen}
          setPrivateOfferDetailsOpen={setPrivateOfferDetailsOpen}
          setManageOfferDatas={setManageOfferData}
          manageOfferData={manageOfferData}
          setOpensolicitorpopup={setOpensolicitorpopup}
          setTypeofsolicitorpopup={setTypeofsolicitorpopup}
        />
      )}

      {viewPrivateOfferlinkpopup && (
        <Privateofferdetailslink
          open={viewPrivateOfferlinkpopup}
          address={
            getBuyerIndividualValue?.PropertyDetails?.propertyAddress
              ?.streetName
          }
          setViewPrivateOffer={setManageOffer}
          setViewPrivateOfferlinkpopup={setViewPrivateOfferlinkpopup}
        />
      )}

      {/* Moved PrivateOfferDetails outside ManageOffer */}
      <PrivateOfferDetails
        open={privateOfferDetailsOpen}
        setPrivateOfferDetailsOpen={setPrivateOfferDetailsOpen}
        getBuyerIndividualValue={getBuyerIndividualValue}
        manageOfferData={manageOfferData}
        propertyDetails={props.propertyDetails}
        setManageOffer={setManageOffer}
        groupIt={groupIt}
        groupCall={groupCall}
        getListInfo={props.getListInfo}
        manageOfferClickclosing={manageOfferClickClose}
        setOpensolicitorpopup={setOpensolicitorpopup}
        setTypeofsolicitorpopup={setTypeofsolicitorpopup}
      />
    </Grid>
  );
}
